import {useState} from 'react'
import {Calendar, type DayOfWeek} from '@mantine/dates'
import dayjs, {type Dayjs} from 'dayjs'
import {isInWeek} from '../../../screens/calendar/components/time/isInWeek.ts'
import {DisabledWrapper} from '../../disabledWrapper/DisabledWrapper.tsx'
import type {DateRange} from '../DateRangeSelector.tsx'

type Props = {
  value: DateRange
  onValueChange: (dateRange: DateRange) => void
  maxDate: Dayjs | undefined
  disabled: boolean
}

export const WeekSelector = ({value, onValueChange, maxDate, disabled}: Props) => {
  const [hovered, setHovered] = useState<DateRange>()

  return (
    <DisabledWrapper disabled={disabled}>
      <Calendar
        withCellSpacing={false}
        highlightToday
        firstDayOfWeek={dayjs.localeData().firstDayOfWeek() as DayOfWeek}
        getDayProps={(_date) => {
          const day: DateRange = {
            start: dayjs(_date).startOf('day'),
            end: dayjs(_date).endOf('day'),
          }
          const week: DateRange = {
            start: day.start.startOf('week'),
            end: day.start.endOf('week'),
          }

          const isHovered = hovered ? isInWeek(hovered, day.start) : false
          const isSelected = isInWeek(value, day.start)
          const isInRange = isHovered || isSelected
          return {
            onMouseEnter: () => setHovered(week),
            onMouseLeave: () => setHovered(undefined),
            inRange: isInRange,
            firstInRange: day.start.isSame(value.start) || (hovered && day.start.isSame(hovered.start)),
            lastInRange: day.end.isSame(value.end) || (hovered && day.end.isSame(hovered.end)),
            selected: isSelected,
            onClick: () => onValueChange(week),
          }
        }}
        maxDate={maxDate?.toDate()}
        static={disabled}
      />
    </DisabledWrapper>
  )
}
